import ko from "knockout";
import SelectListItemModel from "../../../custom/selectlist-item-model";
import { CustomError, customFetch as fetch } from "../../../fetch";

export default class AdministrationInfo {
    parent: any;
    saving: KnockoutObservable<boolean>;
    validationErrors: KnockoutObservableArray<CustomError>;
    shouldDisableFields: KnockoutObservable<boolean>;

    fooksRelationshipManagers: KnockoutObservableArray<SelectListItemModel>;
    relationshipManagerId: KnockoutObservable<string>;

    accountManagers: KnockoutObservableArray<SelectListItemModel>;
    accountManagerId: KnockoutObservable<string>;    

    isPayrollCustomer: KnockoutObservable<boolean>;
    isSalaryAdministrationCustomer: KnockoutObservable<boolean>;
    isEventCustomer: KnockoutObservable<boolean>;
    isProfriCustomer: KnockoutObservable<boolean>;
    profriCustomerHasOwnKickback: KnockoutObservable<boolean>;

    companyHasCurrentPayrollEmployees: KnockoutObservable<string>;
    whatToDoWithExistingContracts: KnockoutObservable<string>;

    customerReferredBy: KnockoutObservable<string>;

    digitalDocumentSigningPrice: KnockoutObservable<number>;
    checkoutIntegrationPrice: KnockoutObservable<number>;

    ratePerPaycheck: KnockoutObservable<number>;
    ratePerHour: KnockoutObservable<number>;
    oneTimeImplementationCosts: KnockoutObservable<number>;

    constructor(model: any, parent: any) {
        this.parent = parent;
        this.saving = ko.observable<boolean>(false);
        this.validationErrors = ko.observableArray<CustomError>();
        this.shouldDisableFields = ko.pureComputed(() => this.parent.onboardingStatus() !== 1);

        this.isPayrollCustomer = ko.observable<boolean>(model.is_payroll_customer || false).extend({
            errorHandler: { source: this.validationErrors, id: 'IsPayrollCustomer' }
        });
        this.isSalaryAdministrationCustomer = ko.observable<boolean>(model.is_salary_administration_customer || false).extend({
            errorHandler: { source: this.validationErrors, id: 'IsSalaryAdministrationCustomer' }
        });
        this.isEventCustomer = ko.observable<boolean>(model.is_event_customer || false).extend({
            errorHandler: { source: this.validationErrors, id: 'IsEventCustomer' }
        });
        this.isProfriCustomer = ko.observable<boolean>(model.is_profri_customer || false).extend({
            errorHandler: { source: this.validationErrors, id: 'IsProfriCustomer' }
        });
        this.profriCustomerHasOwnKickback = ko.observable<boolean>(model.profri_customer_has_own_kickback || false).extend({
            errorHandler: { source: this.validationErrors, id: 'ProfriCustomerHasOwnKickback' }
        });

        this.companyHasCurrentPayrollEmployees = ko.observable<string>(model.company_has_current_payroll_employees === null ? null : model.company_has_current_payroll_employees.toString()).extend({
            errorHandler: { source: this.validationErrors, id: 'CompanyHasCurrentPayrollEmployees' }
        });
        this.whatToDoWithExistingContracts = ko.observable<string | null>(model.what_to_do_with_existing_contracts || null).extend({
            errorHandler: { source: this.validationErrors, id: 'WhatToDoWithExistingContracts' }
        });

        this.customerReferredBy = ko.observable<string | null>(model.customer_referred_by || null).extend({
            errorHandler: { source: this.validationErrors, id: 'CustomerReferredBy' }
        });

        this.digitalDocumentSigningPrice = ko.observable<number>(model.digital_document_signing_price || 0).extend({
            errorHandler: { source: this.validationErrors, id: 'DigitalDocumentSigningPrice' }
        });
        this.checkoutIntegrationPrice = ko.observable<number>(model.checkout_integration_price || 0).extend({
            errorHandler: { source: this.validationErrors, id: 'CheckoutIntegrationPrice' }
        });
        
        this.ratePerPaycheck = ko.observable<number>(model.rate_per_paycheck || 0).extend({
            errorHandler: { source: this.validationErrors, id: 'RatePerPaycheck' }
        });
        this.ratePerHour = ko.observable<number>(model.rate_per_hour || 0).extend({
            errorHandler: { source: this.validationErrors, id: 'RatePerHour' }
        });
        this.oneTimeImplementationCosts = ko.observable<number>(model.one_time_implementation_costs || 0).extend({
            errorHandler: { source: this.validationErrors, id: 'OneTimeImplementationCosts' }
        });

        this.companyHasCurrentPayrollEmployees.subscribe((newValue) => {
            if (newValue) this.whatToDoWithExistingContracts(null);
        });

        this.fooksRelationshipManagers = ko.observable<SelectListItemModel>([
            new SelectListItemModel({ id: 'B88A05DD-8EC5-431D-9768-9E9DBE2ECBF7', name: 'Debbie Brugman' }),
            new SelectListItemModel({ id: 'ea32a3c7-05d4-409a-8ca4-f09ffb00a8c3', name: 'Lieke Derks' }),
            new SelectListItemModel({ id: 'ba3fae87-8ee9-4ea2-958c-6986f9d2f339', name: 'Debbie van Lijssel' }),
            new SelectListItemModel({ id: '2132aaea-f99d-429c-8120-a49393f6a212', name: 'Lieke Ingenbleek' }),
            new SelectListItemModel({ id: '846f468a-7a2b-4141-b73f-06f3acdc3251', name: 'Pascal van rijsbergen' }),
            new SelectListItemModel({ id: 'A0123F00-A832-4E00-A2FE-C8BA19442F83', name: 'Joyce Wubben' }),
            new SelectListItemModel({ id: '52744c28-741d-4b45-a626-34dd432c0e8d', name: 'Bram Gommers' }),
            new SelectListItemModel({ id: 'd5301f1f-6b29-45be-9656-76ca5caea295', name: 'Floor Thiele' }),
            new SelectListItemModel({ id: '1ca9364c-8379-4637-8935-9d932b469ca0', name: 'Daan Willems' }),
        ]);

        this.relationshipManagerId = ko.observable<string>(model.relationship_manager_id || "").extend({
            errorHandler: { source: this.validationErrors, id: 'RelationshipManagerId' }
        });

        this.accountManagers = ko.observable<SelectListItemModel>([
            new SelectListItemModel({ id: '1736B29B-98C7-4731-B358-CF7A26C621DF', name: 'Max Derks' }),
            new SelectListItemModel({ id: '33313097-aeb0-4fbc-897a-b14b8ac95994', name: 'Robert Rademacher' }),
            new SelectListItemModel({ id: 'DA1E87EC-AF72-47EF-A196-C64CCA634BB2', name: 'Mylon Poelen' }),
            new SelectListItemModel({ id: '63407143-3b7a-4c34-b232-5d6c825f3582', name: 'Danny Hirschmann' })
        ]);

        this.accountManagerId = ko.observable<string>(model.account_manager_id || "").extend({
            errorHandler: { source: this.validationErrors, id: 'AccountManagerId' }
        });
    }

    
    async submit() {
        this.saving(true);
        this.parent.submit();
        this.saving(false);
    }
    
    toJson() {
        return {
            is_payroll_customer: this.isPayrollCustomer(),
            is_salary_administration_customer: this.isSalaryAdministrationCustomer(),
            is_event_customer: this.isEventCustomer(),
            is_profri_customer: this.isProfriCustomer(),
            profri_customer_has_own_kickback: this.profriCustomerHasOwnKickback(),
            relationship_manager_id: this.relationshipManagerId(),
            account_manager_id: this.accountManagerId(),
            digital_document_signing_price: this.digitalDocumentSigningPrice(),
            checkout_integration_price: this.checkoutIntegrationPrice(),
            customer_referred_by: this.customerReferredBy(),
            rate_per_paycheck: this.ratePerPaycheck(),
            rate_per_hour: this.ratePerHour(),
            one_time_implementation_costs: this.oneTimeImplementationCosts(),
            company_has_current_payroll_employees: this.companyHasCurrentPayrollEmployees() === null 
                ? null 
                : this.companyHasCurrentPayrollEmployees() === "true",
            what_to_do_with_existing_contracts: this.whatToDoWithExistingContracts()
        };
    }

    async validateModel() {
        const url = '/admin/CompanyOnboarding/ValidateAdministrationModel';

        const body= this.toJson();

        const response = await fetch(url, {
            headers: {
                'Content-type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            this.parent.validationIsSuccessful = false;
            if (response.errors && response.errors.length > 0) {
                this.validationErrors(response.errors);
            }
        }
    }
}
